module.exports = __webpack_public_path__ + "img/image-10.b07cd064.jpeg";